import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const isDesktop = useIsDesktop();

  return (
    <Stack mb={isDesktop ? '16px' : undefined}>
      <Typography
        component='h1'
        variant='h2'
        m={isDesktop ? '0 0 56px' : '0 0 16px'}
        tabIndex={0}
      >
        {dictionary.hereYouOrderConsumableEquipment}
      </Typography>
      <Typography component='h2' variant='h5' m='0 0 8px'>
        {dictionary.whatIsConsumableEquipment}
      </Typography>
      <Typography component='h3' variant='body3' m='0'>
        {
          dictionary.medicalEquipmentWillBeProvidedInAccordanceWithTheMedicalRecommendations
        }
      </Typography>
    </Stack>
  );
};
